import { AccessTime } from '@mui/icons-material'
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'

import useStyles from '../index.styles'

interface RecentSearchItemProps {
  item: RecentSearchItem
  onClick: () => void
}

const RecentSearchItem = ({ item, onClick }: RecentSearchItemProps) => {
  const classes = useStyles
  return (
    <MenuItem onClick={onClick} tabIndex={0} data-testid="search-result-item">
      <ListItemIcon sx={classes.searchMenuItemIcon}>
        <AccessTime />
      </ListItemIcon>
      <ListItemText
        primary={item.searchQuery}
        className="fs-exclude"
        slotProps={{
          primary: {
            variant: 'subtitle1',
          },
        }}
      />
    </MenuItem>
  )
}

export default RecentSearchItem
